export default function Loader() {
    return <div className="relative ml-3.5">
        <span className="loader top-0 left-0"></span>
    </div>
}